import { useEditorUI } from "@pathwright/blocks-engine"
import styled from "styled-components"
import { defaultBlockStyles } from "../editor/BlockStyles/base-style-defaults"

const StyledBlockWrapper = styled.div`
  padding: ${defaultBlockStyles.styleAttributes.paddingTop}
    ${defaultBlockStyles.styleAttributes.paddingRight};
  position: relative;
  transition: all 0.3s;

  .ql-bubble .ql-editor {
    h1 {
      font-size: 42px;
    }

    h2 {
      font-size: 36px;
    }

    h3 {
      font-size: 32px;
    }
  }

  .ContentText .ql-editor {
    padding: 0px;
    overflow: visible;

    /* Solves Safari printing bug */
    @media print {
      & {
        height: auto !important;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 15px 0px;
    padding-top: ${(props) => (props.editing ? 20 : 15)}px;
  }

  // Apply block styles text colors
  ${(p) =>
    p.styledColor
      ? `
    .ql-editor,
    .ql-editor > *,
    .ql-editor.ql-blank::before,
    .SubText,
    .SubText > *,
    .BlockText,
    .BlockText > *:not(pre),
    .ContentText .ql-blank:before,
    .MatchingMatchInput,
    .MatchingMatchInput::placeholder {
      color: ${p.styledColor};
      transition: color 0.5s;
    }

    .ql-editor.ql-blank::before,
    .MatchingMatchInput::placeholder {
      opacity: 0.6;
    }
  `
      : ""}

  .BlockValidationIndicator {
    position: absolute;
    top: 40px;
    left: 10px;

    @media (min-width: 769px) {
      left: 20px;
    }
  }

  @keyframes highlight {
    from {
      background-color: rgba(255, 255, 0, 0.5);
    }
    to {
      background-color: transparent;
    }
  }

  &:hover .block-link-icon {
    opacity: 1;
  }

  // uncomment the styles below for testing currently selected Blocks via the URL hash
  &.is-targeted-in-hash::after {
    // content: "";
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
    // width: 100%;
    // height: 100%;
    // background-color: rgba(255, 255, 0, 0.5);
  }

  @media print {
    & {
      height: max-content;
    }
    &.smooth-scroll-active {
      display: none;
    }
  }
`

export const EditorBlockWrap = ({
  children,
  className = "",
  styledColor,
  index,
  style
}) => {
  const { setFocusedBlockIndex } = useEditorUI()

  const handleFocus = () => {
    setFocusedBlockIndex(index)
  }

  const handleBlur = () => {
    setFocusedBlockIndex(null)
  }

  return (
    <StyledBlockWrapper
      styledColor={styledColor}
      className={`BlockWrap ${className}`}
      style={style}
      editing={true}
      onBlur={handleBlur}
      onFocus={handleFocus}
    >
      {children}
    </StyledBlockWrapper>
  )
}

// View mode only
const BlockWrap = ({ children, className = "", styledColor, style, block }) => {
  return (
    <StyledBlockWrapper
      styledColor={styledColor}
      className={`BlockWrap ${className} block-type-${block.type}-${block.layout}`}
      style={style}
      id={`block-${block.id}`}
    >
      {children}
    </StyledBlockWrapper>
  )
}

export default BlockWrap
